import { render } from "./AlarmConfigurationReport.vue?vue&type=template&id=ef6c5c56"
import script from "./AlarmConfigurationReport.vue?vue&type=script&lang=js"
export * from "./AlarmConfigurationReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__